import React, { useMemo, useState } from 'react'
import {
  WorkSchedule,
  WORK_SCHEDULE_DEMO_DAY_HEADERS,
  WORK_SCHEDULE_DEMO_STAFF,
} from '@components/ui'
import UiPreviewCanvas from '../components/UiPreviewCanvas'
import './WorkScheduleShowcase.css'

const WorkScheduleShowcase: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const pagedStaff = useMemo(() => {
    const start = (currentPage - 1) * pageSize
    return WORK_SCHEDULE_DEMO_STAFF.slice(start, start + pageSize)
  }, [currentPage, pageSize])

  return (
    <UiPreviewCanvas
      title="Work schedule"
      description="Weekly staff schedule grid with shift, day-off, and half-day cells — as used in Settings → Team → Work schedule."
      stageClassName="ui-preview__stage--wide work-schedule-showcase__stage-wrap"
    >
      <div
        className={`work-schedule-showcase__sheet${
          darkMode ? ' work-schedule-showcase__sheet--dark' : ''
        }`}
      >
        <section
          className={`ui-showcase-live${
            darkMode ? ' ui-showcase-live--dark' : ''
          }`}
        >
          <div className="work-schedule-showcase__live-header">
            <h3 className="ui-showcase-live__title">Live preview</h3>
            <label className="work-schedule-showcase__dark-toggle">
              <input
                type="checkbox"
                checked={darkMode}
                onChange={(event) => setDarkMode(event.target.checked)}
              />
              <span>Dark mode</span>
            </label>
          </div>
          <div className="work-schedule-showcase__live">
            <WorkSchedule
              dayHeaders={WORK_SCHEDULE_DEMO_DAY_HEADERS}
              staff={pagedStaff}
              darkMode={darkMode}
              pagination={{
                currentPage,
                pageSize,
                totalRecords: WORK_SCHEDULE_DEMO_STAFF.length,
                pageSizeOptions: [10, 25, 50, 100],
                onPageChange: setCurrentPage,
                onPageSizeChange: (next) => {
                  setPageSize(next)
                  setCurrentPage(1)
                },
              }}
            />
          </div>
        </section>
      </div>
    </UiPreviewCanvas>
  )
}

export default WorkScheduleShowcase
